<template>
	<div>
		<Modal v-model="modal.ifShow" :title="modal.Title" width="30%" :mask-closable="false" :closable="false">
			
			<Form :rules="ruleInline" label-position="right" v-if="modal.type=='resetpassword'" ref="userForm"
				:model="userInfo" :label-width="90">
				
				<Row :gutter="20" style="margin-bottom: 10px;">
					<Col span=16>
					<FormItem :label="$t('Common.Password')" prop="Password">
						<Input  v-model="userInfo.Password" :placeholder="$t('Common.Password')"></Input>
					</FormItem>
					</Col>
				
				</Row>
				
			</Form>
	
			<div v-if="modal.type=='resetpassword'" slot="footer">
				<Button type="warning" @click="modalOk('cancle')" size="large">{{ $t('Common.Cancel') }}</Button>
				<Button type="success" @click="modalOk('resetpassword')" size="large">{{ $t('Common.Reset') }}</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import dateFormat from '../../../../../public/js/comm.js'
	import webapi from '../../../../webapi.js';
	export default {
		data() {
			const validateOpId = (rule, value, callback) => {
				if (this.modal.type == 'up') {
					callback();
				} else {
					if (value === '') {
						callback(new Error(this.$t('UserManagement.InputPassword')));
					} else {
						callback();
					}
				}
			};
			return {
				modal: {
					Title: this.$t('Common.ResetPassword'),
					type: "resetpassword",
					ifShow: false,
					canInput: false
				},
				
				userInfo: {
					
					"Id": 0,
					"Password": "",
					
				},
				zindex: 2000,
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				imgName: '',
				visible: false,

				/****************/
				OperatorStation: [],
				// Validate Fields
				ruleInline: {
					// Name: [{
					// 	validator: validateOpId,
					// 	trigger: 'blur',
					// }],
					Password: [{
						validator: validateOpId,
						trigger: 'blur',
					}],
				
				
				},
			};
		},
		methods: {
			
			show: function(type, params) {
				const _this = this;
				if (type == "add") {
					_this.modal.Title = this.$t('Common.Add');
					_this.modal.type = "add";
					_this.ruleInline.Password.required = true;
					_this.userInfo.Id = 0;
					_this.$refs.userForm.resetFields()
				} else if (type == "resetpassword") {
					_this.modal.Title = this.$t('Common.ResetPassword');
					_this.modal.type = "resetpassword";
					_this.ruleInline.Password.required = true;
					_this.$refs.userForm.resetFields()
					console.log(params)
					_this.userInfo = {
						"Id": params.Id,
						"Password": params.Password,
					};
				}
				_this.modal.ifShow = true
			},
			
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal.ifShow = false
						break;
					case 'add':
						_this.modal.ifShow = true
						_this.addUser(type);
						break;
					case 'resetpassword':
						_this.modal.ifShow = true
						_this.addUser(type);
						break;
					default:
						break;
				}
			},
			
			addUser: function(type) {
				const _this = this;
				let parms = _this.userInfo
						console.log(_this.userInfo)
						_this.$axios.post(webapi.base_api_url + "/System/ResetPassword", parms, {}).then(res => {
							console.log("Add")
							console.log(res.data)
							if (res.data.Code == 0) {
								this.$Message.success(type == 'add' ? this.$t('Common.AddSuccess') : this.$t('Common.EditSuccess'));
								_this.$emit('handleSubmit');
								_this.modalOk("cancle")
							} else {
								this.$Message.error(res.data.Msg + "---" + res.data.Data);
							}
						})

			},
			GetCurrentOperatorStation: function() {
				const _this = this;
				_this.$axios.post(webapi.base_api_url + "/System/GetCurrentOperatorStation", {}, {}).then(res => {
					console.log("Get station start")
					console.log(res.data)
					if (res.data.Code == 0) {
						_this.OperatorStation = res.data.Data.List
					} else {
						_this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			/**********Component Method*********/
			handleView(name) {
				this.imgName = name;
				this.visible = true;
			},
			handleRemove(file) {
				console.log(file)
				const _this = this
				if (_this.PictureDelCache.indexOf(file.name) > 0) {
					console.log('Delete cache ')
				} else {
					console.log('Cache is not exist')
					_this.PictureUpCache.push(file.name)
				}
				const fileList = _this.$refs.upload.fileList;
				_this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				_this.$nextTick(() => {
					
					_this.uploadList = _this.$refs.upload.fileList
					_this.defaultList = _this.$refs.upload.fileList
				})
				_this.StationPicturesArray = _this.StationPicturesArray.filter(function(item, index,
					arr) {
					console.log(file.name)
					return item != file.name
				})
			},
			handleSuccess(res, file) {
				if (res.Code == 0) {
					file.url = webapi.base_api_url + res.Data;
					file.name = res.Data;
					let itemLen = this.defaultList.length;
					this.$set(this.defaultList, itemLen, file);
					this.uploadList = this.defaultList
					this.StationPicturesArray.push(file.name)
					this.PictureDelCache.push(file.name)
				}
				//file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
				//file.name = '7eb99afb9d5f317c912f08b5212fd69a';
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: this.$t('Common.FormatError'),
					desc: this.$t('Common.SelectJpgOrPng')
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: this.$t('Common.ImageTooLarge'),
					desc: this.$t('Common.File') + file.name + ' '+this.$t('Common.SelectSmallerImg')
				});
			},
			handleBeforeUpload() {
				const check = this.uploadList.length < 5;
				if (!check) {
					this.$Notice.warning({
						title: 'Up to five pictures can be uploaded.'
					});
				}
				return check;
			},
			OperatorNameChange: function(a) {
				console.log(a)
				this.StationForm.OperatorId = a;
			}
		},
		created() {
			this.GetCurrentOperatorStation()
		},
		mounted() {
			this.upHeader.Authorization = "Bearer " + encodeURIComponent(localStorage.AccessToken);
		},
		computed: {
			
			OperatorStationFilter: function() {
				const _this = this
				let staArr = []
				_this.OperatorStation.forEach(function(item, index, arr) {
					if (item.OperatorId == _this.userInfo.OperatorId) {
						staArr = (item.Stations)
					}
				})
				console.log(staArr);
				return staArr
			},
			...mapState({
				StationList: 'Stations',
				RoleList: 'roleList',
				OperatortypeList: 'typeList'
			})
		}
	}
</script>

<style>
</style>
